/**
 * Quais falas do turno já vêm MARCADAS quando o modal "Responder de novo" abre.
 *
 * Regra: só a ÚLTIMA. É o caso comum (a cliente pergunta uma coisa e a Sara
 * erra), e faz o operador MARCAR o que falta em vez de ter que DESMARCAR o que
 * já foi bem respondido.
 *
 * Marcar tudo por padrão seria o pior default: numa rajada como a da Fernanda
 * (30/07/2026 — "bom dia" + "pode tirar a carta do dia?" + "queria ver dois
 * sonhos"), confirmar sem pensar faria a Sara reler o pedido de carta e mandar
 * uma SEGUNDA carta no mesmo dia. O default seguro é o mínimo.
 */
export function selecaoPadraoDoTurno(idsDoTurno: readonly string[]): string[] {
  const ultima = idsDoTurno[idsDoTurno.length - 1];
  return ultima ? [ultima] : [];
}
